import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { Location } from '@angular/common';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { ButtonComponent } from 'htx-ui-library';

@Component({
  selector: 'app-glossary-page',
  standalone: true,
  imports: [TranslocoDirective, TranslocoPipe, ButtonComponent],
  templateUrl: './glossary-page.component.html',
  styleUrl: './glossary-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GlossaryPageComponent {
  private location = inject(Location);

  goBack(): void {
    this.location.back();
  }
}
